import useQuery from "utils/hooks/useQuery";
import ForgotPasswordForm from "features/auth/ForgotPasswordForm";
import ResetPasswordForm from "features/auth/ResetPasswordForm";

const ResetPassword = () => {
  const query = useQuery();
  const token = query.get("token");

  return token ? <ResetPasswordForm token={token} /> : <ForgotPasswordForm />;
};

export default ResetPassword;
